import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    issuesList: [],
    issuesData: [],
    modelList: [],
    categoryList: [],
    rulesList: [],
    ruleSetList: [],
    issueCount: 0,
  },
  getters: {
    issuesList: (state) => state.issuesList,
    issuesData: (state) => state.issuesData,
    modelList: (state) => state.modelList,
    categoryList: (state) => state.categoryList,
    rulesList: (state) => state.rulesList,
    ruleSetList: (state) => state.ruleSetList,
    needResolveIssue: (state) => state.issueCount > 0,
    issueCount: (state) => state.issueCount,
  },
  actions: {
    loadIssuesList(context, params) {
      const { page, size, status } = params;
      const resolvePage = page - 1;
      return new Promise((resolve, reject) => {
        alice
          .searchIssues(size, resolvePage, status)
          .then((response) => {
            const { data } = response.data;
            context.commit('setIssuesData', data);
            // Ensure no link
            const content = JSON.parse(JSON.stringify(data.content));
            context.commit('setIssuesListData', content);
            if (status && status.length === 0) {
              context.commit('setIssueCount', data.totalElements);
            }
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadIssuesCount(context) {
      return new Promise((resolve, reject) => {
        alice
          .searchIssues(10, 0, [])
          .then((response) => {
            const { data } = response.data;
            context.commit('setIssueCount', data.totalElements);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    resolveIssue(context, params) {
      const { id, type } = params;
      return new Promise((resolve, reject) => {
        alice
          .resolveIssue(id, type)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    markResolveIssue(context, params) {
      const { id } = params;
      return new Promise((resolve, reject) => {
        alice
          .markResolveIssue(id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadModelList(context) {
      return new Promise((resolve, reject) => {
        alice
          .loadModelList()
          .then((response) => {
            const { data } = response.data;
            data.forEach((model) => {
              const newModel = model;
              if (newModel.lastTrainedAt) {
                newModel.isOutdated = newModel.updatedAt > newModel.lastTrainedAt;
              } else {
                newModel.isOutdated = true;
              }
            });
            context.commit('setModelListData', data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadCategoryList(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadCategoryList(modelId)
          .then((response) => {
            context.commit('setCategoryListData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    resetCategoryList(context) {
      context.commit('setCategoryListData', []);
    },
    loadRulesList(context) {
      return new Promise((resolve, reject) => {
        alice
          .loadRuleSet()
          .then(async (response) => {
            const ruleSet = response.data;
            context.commit('setRuleSetListData', response.data);
            const promiseArr = [];
            const ruleSetNameMap = {};
            for (let i = 0; i < ruleSet.length; i += 1) {
              const setId = ruleSet[i].id;
              const setName = ruleSet[i].name;
              ruleSetNameMap[setId] = setName;
              promiseArr.push(alice.loadRulesBySet(setId));
            }

            try {
              const allRulesData = await Promise.all(promiseArr);
              const allRulesList = allRulesData.map((result) => {
                const rules = result.data;
                if (rules[0]) {
                  const setId = rules[0].ruleSetId;
                  const setName = ruleSetNameMap[setId];
                  for (let j = 0; j < rules.length; j += 1) {
                    rules[j].setName = setName;
                    rules[j].setId = setId;
                  }
                }
                return rules;
              });
              let finalRules = [];
              allRulesList.forEach((rules) => {
                finalRules = finalRules.concat(rules);
              });
              context.commit('setRulesListData', finalRules);
              resolve(finalRules);
            } catch (e) {
              context.commit('setRulesListData', []);
              reject(e);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteIssue(context, params) {
      const { id } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteIssue(id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createIssue(context, params) {
      const { text } = params;
      return new Promise((resolve, reject) => {
        alice
          .createIssue(text)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setIssuesListData(state, data) {
      Vue.set(state, 'issuesList', data);
    },
    appendIssuesListData(state, data) {
      const newData = state.issuesList.concat(data);
      Vue.set(state, 'issuesList', newData);
    },
    setIssuesData(state, data) {
      Vue.set(state, 'issuesData', data);
    },
    setIssueCount(state, data) {
      Vue.set(state, 'issueCount', data);
    },
    setModelListData(state, data) {
      Vue.set(state, 'modelList', data);
    },
    setCategoryListData(state, data) {
      Vue.set(state, 'categoryList', data);
    },
    setRulesListData(state, data) {
      Vue.set(state, 'rulesList', data);
    },
    setRuleSetListData(state, data) {
      Vue.set(state, 'ruleSetList', data);
    },
  },
};
